import { createSelector } from 'reselect';
import moment from 'moment';

const statePolicySelector = (state) => state.policy;

export const policySelector = createSelector([statePolicySelector], (policy) => {
	(policy.items || []).sort((a, b) => a.policyNumber < b.policyNumber ? - 1 : 1 ).forEach((policy) => {
		policy.effectiveRange = `${moment(policy.term.effectiveDate).format('MM/DD/YYYY')} - ${moment(policy.term.endDate).format('MM/DD/YYYY')}`;
		policy.effective = `${moment(policy.term.effectiveDate).format('MM/DD/YYYY')}`;
		policy.expiration = `${moment(policy.term.endDate).format('MM/DD/YYYY')}`;
		policy.statusText = policy.status === 'History' ? 'Cancelled' : policy.status;

		policy.isAccountBill = policy.billing.isPartOfAccountBill;
		policy.accountBillId = policy.billing.accountBillId;
		policy.accountNumber = policy.billing.accountNumber;
	});
	
	return { ...policy };
});